import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toggleGuestMode} from '../../../actions';

class PreviewProfile extends Component {
    render() {
        const {dispatch, guestMode } = this.props;
        return (
            <div className="row">
                <div className="col-xs-8 col-md-9">
                    <p className="p-tag">You can check how other members see your profile. Switch to <b>preview mode</b>.</p>
                </div>
                <div className="col-xs-4 col-md-3">
                    <button
                        className={`btn-toggle${ (guestMode) ? ' toggle-on' : ' toggle-off'}`}
                        onClick={ () => dispatch(toggleGuestMode(true)) }>
                        { (guestMode) ? 'on' : 'off' }
                        <span className="dot"> </span>
                    </button>
                </div>
            </div>
        );
    }
}

export default connect()(PreviewProfile);




// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/visibility/PreviewProfile.js